<template>
  <div class="video-demo">
    <video autoplay loop muted :poster="posterLink">
      <source type="video/mp4" :src="mp4Link">
      <source type="video/ogg" :src="oggLink">
      <source type="video/webm" :src="webmLink">
    </video>
    <p>{{description}}</p>
  </div>
</template>

<script>
export default {
  name: 'VideoDemo',
  components: {
  },
  props: {
    source: String,
    description: String
  },
  computed: {
    posterLink: function () {
      return this.source + '_cover.jpg'
    },
    mp4Link: function () {
      return this.source + '.mp4'
    },
    oggLink: function () {
      return this.source + '.ogg'
    },
    webmLink: function () {
      return this.source + '.webm'
    }
  },
  methods: {
    getLink: function (source, ext) {
      return source + ext
    }
  }
}
</script>

<style lang = "less" scoped>
@import (reference) "../../assets/styles/main.less";

.video-demo {
  max-width: 400px;
  padding: 30px;

  video {
  }

  p {
    font-family: "Share Tech";
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Home/VideoDemo.vue